import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import classes from './Preview.module.css';
import Button from 'components/UI/Button/Button';
import CustomCheckbox from 'components/UI/CustomCheckbox/CustomCheckbox';
import FormDialogue from 'components/UI/FormDialogue/FormDialogue';
import PostDetail from 'containers/Posts/PostDetail/PostDetail';
import * as actions from 'store/actions';

const GiftMessageDialogue = (props) => {
  return (
    <FormDialogue
      show
      className="GiftMessage"
      title="Send Gift Post"
      confirmText="SEND"
      cancelText="CANCEL"
      confirm={props.confirm}
      cancel={props.cancel}
    >
      <div className={classes.GiftMessageContainer}>
        <textarea placeholder="Add a brief note if you want…" onChange={props.onChange} />
        <CustomCheckbox checked={props.onSaveCopy} label="Save a copy of this post in my drafts" value={props.saveCopy} />
      </div>
    </FormDialogue>
  );
};

const Preview = (props) => {
  const [state, setState] = useState({
    showGiftMessageDialogue: false,
    saveCopy: false,
    messageText: '',
    // redirectPath: null,
  });

  const history = useHistory();
  const dispatch = useDispatch();

  const post = useSelector((s) => s.post.fetchedPreviewPost);
  const postImages = useSelector((s) => (s.post.postImages.length > 0 ? s.post.postImages : []));
  const postingAs = useSelector((s) => s.user.postingAs);
  const isManagedUser = useSelector((s) => s.user.postingAs.UserId !== s.user.signedInAs.UserId);
  const loading = useSelector((s) => s.post.loading);
  const redirectPath = useSelector((s) => s.post.redirectPath);
  const logs = useSelector((s) => s.logs.LogsDetails);

  const returnToLog = useCallback(() => {
    const path = redirectPath || '/life-shared/timeline/';
    history.push({
      pathname: path,
      state: { prevPath: 'preview' },
    });
  }, [history, redirectPath]);

  const onReturnToPostForm = useCallback((isGift) => dispatch(actions.returnToPostForm(isGift)), [dispatch]);
  const onFetchLogsDetails = useCallback((userId, imu, LogId) => dispatch(actions.fetchLogsDetails(userId, imu, LogId)), [dispatch]);

  const handlePostSubmit = () => {
    // const addFileIds = postImages.map((image) => image.Id);
    const geoLocation = post.Post.MapLat && post.Post.MapLng ? { lat: post.Post.MapLat, lng: post.Post.MapLng } : null;
    const center = post.Post.Lat && post.Post.Lng ? { lat: post.Post.Lat, lng: post.Post.Lng } : null;
    if (post.Post.PostId && !post.Post.isGift) {
      dispatch(
        actions.editPost(
          post.Post.PostId,
          post.Post.LogIds,
          post.Post.Name,
          post.Post.Type,
          post.Post.DateStart,
          post.Post.DateEnd,
          post.Post.TimeStart,
          post.Post.TimeEnd,
          post.Post.Desc,
          post.Post.ImageIds,
          [],
          post.Tags.WhatTags,
          post.Tags.WhoTags,
          post.Tags.LocationTags,
          props.RemovedImageIds,
          post.Post.Ongoing,
          post.Post.Location,
          post.Post.Location2,
          post.Post.LocIcon,
          post.Post.LocFav,
          post.Post.FavId,
          post.Post.MapType,
          geoLocation,
          center,
          post.Post.Pitch,
          post.Post.Heading,
          post.Post.Zoom,
          false,
          null,
          post.Post.isManagedUser,
          post.Post.UserId,
        ),
      );
    } else {
      dispatch(
        actions.addPost(
          postingAs.UserId,
          isManagedUser,
          post.Post.LogIds,
          post.Post.Name,
          post.Post.Type,
          post.Post.DateStart,
          post.Post.DateEnd,
          post.Post.TimeStart,
          post.Post.TimeEnd,
          post.Post.Desc,
          post.Post.ImageIds,
          post.Post.SendToUserId,
          post.Tags.WhatTags,
          post.Tags.WhoTags,
          post.Tags.LocationTags,
          post.Post.Ongoing,
          post.Post.Location,
          post.Post.Location2,
          post.Post.LocIcon,
          post.Post.LocFav,
          post.Post.FavId,
          post.Post.MapType,
          geoLocation,
          center,
          post.Post.Pitch,
          post.Post.Heading,
          post.Post.Zoom,
          post.Post.isGift,
          state.messageText,
          state.saveCopy,
        ),
      );
    }

    returnToLog();
  };

  useEffect(() => {
    if (redirectPath) setState((prevState) => ({ ...prevState, redirectPath }));
  }, [redirectPath]);
  useEffect(() => {
    if (!post) returnToLog();
    if (post) onFetchLogsDetails(null, null, post.Post.LogIds.toString());
  }, [onFetchLogsDetails, post, returnToLog]);

  useEffect(() => {
    if (loading === false && post === null) {
      returnToLog();
    }
  }, [loading, post, returnToLog]);

  // if ((redirectPath === null && prevProps.redirectPath !== null) || !post) {
  //   this.returnToLog();
  // }

  const whoCanSeeList = [];

  if (!post) return null;

  if (post && post.Post.LogIds && post.Post.LogIds.length > 0) {
    logs
      .filter((log) => post.Post.LogIds.includes(log.Log.Id))
      .forEach((log) =>
        log.Users.forEach((user) => {
          if (!whoCanSeeList.map((u) => u.UserId).includes(user.UserId)) whoCanSeeList.push(user);
        }),
      );
  }
  return (
    <div className={classes.PreviewContainer}>
      {state.showGiftMessageDialogue && (
        <GiftMessageDialogue
          confirm={handlePostSubmit}
          cancel={() => setState((prevState) => ({ ...prevState, showGiftMessageDialogue: false }))}
          onChange={(event) => setState((prevState) => ({ ...prevState, messageText: event.target.value }))}
          onSaveCopy={() => setState((prevState) => ({ ...prevState, saveCopy: !state.saveCopy }))}
          saveCopy={state.saveCopy}
        />
      )}
      <div className={classes.PreviewBanner}>
        <div className={classes.BannerContainer}>
          <FontAwesomeIcon icon="chevron-left" className={classes.BackIcon} onClick={() => onReturnToPostForm(post.Post.isGift)} />
          <h2>{post && post.Post.isGift ? 'Gift Preview' : 'Preview'}</h2>
          <div className={classes.SubmitPostButton}>
            {post && post.Post.isGift ? (
              <Button
                className
                btnType="SavePost"
                disabled={false}
                clicked={() => setState((prevState) => ({ ...prevState, showGiftMessageDialogue: true }))}
              >
                SEND
              </Button>
            ) : (
              <Button className btnType="SavePost" disabled={false} clicked={handlePostSubmit}>
                {post.Post.PostId ? 'UPDATE POST' : 'CREATE POST'}
              </Button>
            )}
          </div>
        </div>
      </div>
      <PostDetail isPreview isGift={post && post.Post.isGift} postImages={postImages} whoCanSeeList={whoCanSeeList} />
    </div>
  );
};

export default Preview;
